import { render, staticRenderFns } from "./ActivationsDealer.vue?vue&type=template&id=2a79b760"
import script from "./ActivationsDealer.vue?vue&type=script&lang=js"
export * from "./ActivationsDealer.vue?vue&type=script&lang=js"
import style0 from "./ActivationsDealer.vue?vue&type=style&index=0&id=2a79b760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports